import { render } from "./product-colour-selector.vue?vue&type=template&id=af59c2aa"
import script from "./product-colour-selector.vue?vue&type=script&lang=js"
export * from "./product-colour-selector.vue?vue&type=script&lang=js"

import "./product-colour-selector.vue?vue&type=style&index=0&id=af59c2aa&lang=scss"

import exportComponent from "/Users/riccardosirchia/Projects/dryrobe.com-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__